import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';

const Article = () => {
  return (
    <Wrapper>
      <ArticleContainer>
        <Title>{useText('article__title', true)}</Title>
        <Text>{useText('article__text', true)}</Text>
      </ArticleContainer>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  position: relative;
  background-position: center top;
  background-repeat: no-repeat;

  @media ${DESKTOP} {
    background-image: ${({ theme: { imgUrl } }) => imgUrl('article-img-d.jpg')};
    min-height: 255px;
    padding-top: 35px;
    background-position: center;
    background-size: 1920px 100%;
  }

  @media ${TABLET} {
    background-image: ${({ theme: { imgUrl } }) => imgUrl('article-img-d.jpg')};
    min-height: 240px;
    padding-top: 24px;
    background-position: center;
    background-size: 1199px 100%;
  }

  @media ${MOBILE} {
    background-image: ${({ theme: { imgUrl } }) => imgUrl('article-img-d.jpg')};
    min-height: 300px;
    padding-top: 24px;
    background-position: center;
    background-size: 767px 100%;
  }
`;

const ArticleContainer = styled(Container)`
  @media ${DESKTOP} {
    padding-inline-end: 10px;
  }
`;

const Title = styled.div`
  font-weight: 500;
  font-size:  40px;
  line-height: 54px;
  text-align: center;
  color: #c3a789;
  padding: 0 100px;
  margin-bottom: 45px;

  @media ${TABLET} {
    margin-bottom: 38px;
    padding: 0;
  }

  @media ${MOBILE} {
    font-size: 38px;
    padding: 0;
  }
`;

const Text = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 17px;
  text-align: center;
  letter-spacing: -0.1px;
  color: #eee5cc;
  margin-bottom: 20px;

  @media ${TABLET} {
  }

  @media ${MOBILE} {
    max-width: 333px;
  }
`;

export default Article;
